import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { DoublingEditorComponent } from '../../non-plc/costsavings/doubling-editor.component';
import { serverMessage } from 'src/app/popUpMessages/serverMessage';
import { SupplierTargetService } from 'src/app/services/suppliertarget.service';
import { AlertDialogComponent } from 'src/app/alert-dialog/alert-dialog.component';
import { merge } from 'rxjs';
import * as XLSX from 'xlsx';
import { SupplierAutocompleteEditorComponent } from './supplier-autocomplete-editor/supplier-autocomplete-editor.component';
import { DeleteiconComponent } from '../../deleteIconNormalGrid/deleteicon.component';

let countryCode;
@Component({
  selector: 'app-suppliertargets',
  templateUrl: './suppliertargets.component.html',
  styleUrls: ['./suppliertargets.component.css']
})
export class SupplierTargetsComponent implements OnInit {

  public showGrid: boolean = true;
  public rowData: any = [];
  public defaultColDef: any;
  public columnDefs: any = [];
  public gridApi: any;
  public gridColumnApi: any;
  public domLayout: any;
  public rowClassRules: any;
  public rowHeight: any;
  public headerHeight: any;

  public alertErrorBox = [];
  public modifiedSupplierTargetrows = [];
  public modifiedExcelSupplierTargetRows = [];
  public errorMessage = []
  public roleMasterData = [];
  public loggedInUser: any;
  public getResponse: any;
  public frameworkComponents: any;
  public sizeToFitRefresh: number = 0;
  public paginationPageSize: any;

  public supplierInfoMaster: any[] = [];
  public supplierNoOptions: string[] = [];
  public supplierName1Options: string[] = [];
  public supplierName2Options: string[] = [];
  public supplierCountryOptions: string[] = [];
  private supplierByNoMap = new Map<string, any>();

  submitResponse: any;
  refObject: any;
  receivedData: any;
  recievedSupplierTargetData: any;
  headerYears: any = [];
  startYear: any = 2024;
  hideExportImport: boolean = true;
  FilterData: any;
  importExcelData: any;
  FinalDatatoSend: any = [];
  Flag: boolean = false;
  s1: any = ["SupplierTarget"];
  yearArr: any = ["2024", "2025", "2026", "2027", "2028", "2029", "2030"];
  public importing = false;
  // changes;
  public adminSubscription: any;
  public unsvdAdminChanges: boolean = false;
  @Output() unSavedChanges = new EventEmitter<any>();

  public roleBusinessArea = [];
  public roleAllBusinessLine = [];
  public roleBusinessLine = [];
  public disableBusinessAreaDropdown: boolean = false;
  public disableBusinessLineDropdown: boolean = false;
  public Editable: boolean = true;

  selectBusinessArea = "";
  selectBusinessLine = "";

  public deleteSubscription: any;


  constructor(
    private sharedService: SharedServiceService,
    public dialog: MatDialog,
    private router: Router,
    private localStorageService: LocalStorageService,
    private toast: ToasterService,
    private supplierTargetService: SupplierTargetService
  ) {
    this.frameworkComponents = {
      doublingEditor: DoublingEditorComponent,
      supplierAutocompleteEditor: SupplierAutocompleteEditorComponent,
      DeleteiconComponent: DeleteiconComponent
    }
  }

  ngOnInit(): void {
    this.sharedService.loggedInUser.subscribe(
      (user: any) => {
        this.loggedInUser = user;

        //getting business area and line access of user
        this.roleBusinessArea = user.BusinessArea;
        this.roleAllBusinessLine = user.BusinessLine;
        //removing duplicates in the list
        this.roleBusinessArea = this.roleBusinessArea.filter((v, i, a) => a.findIndex(v2 => (v2.BusinessAreaId === v.BusinessAreaId)) === i);
        const filteredBusinessLines = this.roleAllBusinessLine.filter(item => item.isTargetCostingAdmin === true);
        this.roleAllBusinessLine = filteredBusinessLines;

        const adminBusinessAreaIds = this.roleAllBusinessLine
          .filter(item => item.isTargetCostingAdmin == true)
          .map(item => item.BusinessAreaId);

        const filteredBusinessArea = this.roleBusinessArea.filter(item =>
          adminBusinessAreaIds.includes(item.BusinessAreaId)
        );

        this.roleBusinessArea = filteredBusinessArea;
        //If the user has only one access, auto populate the dropdown
        if (this.roleBusinessArea.length == 1) {
          this.selectBusinessArea = this.roleBusinessArea[0].BusinessAreaId;
          this.roleBusinessLine = this.roleAllBusinessLine;
          this.disableBusinessAreaDropdown = true;
        }
        if (this.roleAllBusinessLine.length == 1) {
          this.selectBusinessLine = this.roleAllBusinessLine[0].BusinessLineId;
          this.disableBusinessLineDropdown = true;
          this.hideExportImport = false;
        }
        this.showGrid = true;
      }
    );

    this.adminSubscription = this.sharedService.supplierTarget.subscribe(() => {
      this.submit();
    });

    this.deleteSubscription = this.sharedService.supplierTargetDeleteRow.subscribe((rowData: any) => {
      this.onDeleteRow(rowData);
    });

    countryCode = this.localStorageService.get('countryCode');
    this.bindSupplierTargetData();
  }

  onDeleteRow(rowData: any) {
    if (!rowData) return;

    // Determine if this row was ever saved (exists in receivedData)
    const isNewRow = !this.receivedData || !this.receivedData.some(x =>
      x.SupplierNo == rowData.SupplierNo
      && x.Plant == rowData.Plant
      && x.SupplierName1 == rowData.SupplierName1
      && x.SupplierName2 == rowData.SupplierName2
      && x.SupplierCountry == rowData.SupplierCountry
    );

    if (isNewRow) {
      // Never saved → remove from modifiedSupplierTargetrows if it was tracked as an edit
      this.modifiedSupplierTargetrows = this.modifiedSupplierTargetrows.filter(row =>
        !(row.SupplierNo == rowData.SupplierNo
          && row.Plant == rowData.Plant
          && row.SupplierName1 == rowData.SupplierName1
          && row.SupplierName2 == rowData.SupplierName2
          && row.SupplierCountry == rowData.SupplierCountry)
      );
      // No POST needed for a new unsaved row
    } else {
      // Existing DB row: add/replace in modifiedSupplierTargetrows with IsActive=false
      const deletedRow = {
        ...rowData,
        _isDeleted: true,                              // ← flag that datTosSend() checks
        ModifiedBy: this.loggedInUser.UserId,
        ModifiedOn: new Date().toISOString()
      };

      const existingIndex = this.modifiedSupplierTargetrows.findIndex(row =>
        row.SupplierNo == rowData.SupplierNo
        && row.Plant == rowData.Plant
        && row.SupplierName1 == rowData.SupplierName1
        && row.SupplierName2 == rowData.SupplierName2
        && row.SupplierCountry == rowData.SupplierCountry
      );

      if (existingIndex >= 0) {
        // Replace any prior edit entry with the delete entry
        this.modifiedSupplierTargetrows[existingIndex] = deletedRow;  // ← CHANGED
      } else {
        this.modifiedSupplierTargetrows.push(deletedRow);
      }

      this.unSavedChanges.emit({ unsavedChanges: true, saveButtonClick: false });
    }
  }

  updateBusinessLine() {
    this.hideExportImport = true;
    this.selectBusinessLine = "";
    this.roleBusinessLine = this.roleAllBusinessLine.filter(
      bl => bl.BusinessAreaId == Number(this.selectBusinessArea)
    );
    this.bindSupplierTargetData();
  }

  updateSupplierTarget() {
    if (this.selectBusinessLine == "") {
      this.hideExportImport = true;
    }
    else {
      this.hideExportImport = false;
    }
    this.bindSupplierTargetData();
  }


  AddNewSupplier() {
    this.validateRow();
  }

  // Validate the grid data before adding new row
  validateRow() {
    let user = this.loggedInUser;
    this.alertErrorBox = [];
    //let errorMessage = serverMessage.cellEmptyErrorMesssage;

    //To reset the filter and sorting while adding a new row
    this.gridColumnApi.resetColumnState();
    this.gridApi.setFilterModel(null);
    let error = []
    let firstRow = this.gridApi.getDisplayedRowAtIndex(0);

    if (firstRow == undefined) {
      if (error.length == 0) {
        this.gridApi.applyTransaction({
          add: [{
            SupplierNo: null,
            Plant: null,
            SupplierName1: null,
            SupplierName2: null,
            SupplierCountry: null,
            Year: 0,
            IsActive: null,
            CreatedBy: this.loggedInUser.UserId,
            CreatedOn: new Date(),
            ModifiedBy: null,
            ModifiedOn: null,
            _isSupplierTargetRow: true
          }],
          addIndex: 0 // To add the new row at top of the grid
        })
      }
      else if (error.length != 0) {
        this.openAlertDialog(error)
      }
    }
    else {
      let regex = new RegExp(/\^s*$/);

      if (firstRow.data.SupplierNo == "" || firstRow.data.SupplierNo == null || regex.test(firstRow.data.SupplierNo)) {
        //error.push({ "Supplier No": errorMessage })
      }
      if (firstRow.data.Plant == "" || firstRow.data.Plant == null || regex.test(firstRow.data.Plant)) {
      }
      if (firstRow.data.SupplierName1 == "" || firstRow.data.SupplierName1 == null || regex.test(firstRow.data.SupplierName1)) {
        //error.push({ "Supplier Name 1": errorMessage })
      }
      if (firstRow.data.SupplierName2 == "" || firstRow.data.SupplierName2 == null || regex.test(firstRow.data.SupplierName2)) {
        //error.push({ "Supplier Name 2": errorMessage })
      }
      if (firstRow.data.SupplierCountry == "" || firstRow.data.SupplierCountry == null || regex.test(firstRow.data.SupplierCountry)) {
        //error.push({ "Supplier Country": errorMessage })
      }

      if (error.length == 0) {
        this.gridApi.applyTransaction({
          add: [{
            SupplierNo: null,
            Plant: null,
            SupplierName1: null,
            SupplierName2: null,
            SupplierCountry: null,
            Year: 0,
            IsActive: null,
            CreatedBy: this.loggedInUser.UserId,
            CreatedOn: new Date(),
            ModifiedBy: null,
            ModifiedOn: null,
            _isSupplierTargetRow: true
          }],
          addIndex: 0 // To add the new row at top of the grid
        })
      }
      else if (error.length != 0) {
        this.openAlertDialog(error)
      }
    }
  }

  // To show popup message when there is any error
  openAlertDialog(error) {
    this.dialog.open(AlertDialogComponent, { data: error })
  }

  exportGridData() {
    this.showGrid = false;
    this.gridApi.exportDataAsExcel({
      // columnKeys: ['ProductTitle'],
      processCellCallback(params) {
        return params.value ?? 0;
      },
      allColumns: true,
      protection: true,
      sheetName: "SupplierTarget",
      fileName: "SupplierTarget"
    });
    this.showGrid = true;
    this.toast.notify(serverMessage.excelExportMessage, "success");
  }


  importExcel(event: any) {
    // console.log("imported");
    let valToEmit = {
      unsavedChanges: true,
      saveButtonClick: false
    }
    this.unSavedChanges.emit(valToEmit);
    if (event.target.files.length > 0) {
      this.importing = true;
      let file = event.target.files[0];
      //Validation for Excel Types
      let ext = file.name.split('.').pop();
      if (ext != "xlsx") {
        this.importing = false;
        this.toast.notify(serverMessage.excelnotImportMessage, "error"); this.onCancel();
      }
      else {
        // To check the size of the Excel file
        if (event.target.files[0].size / 1024 / 1024 > 10) {
          this.importing = false;
          this.toast.notify(serverMessage.excelImportMessage + ' is More Than 10MB', "error"); this.onCancel();
        }
        else {
          let fileReader = new FileReader();
          fileReader.readAsBinaryString(file);
          fileReader.onload = (e) => {
            let workBook = XLSX.read(fileReader.result, { type: 'binary', cellDates: true });
            let workSheet = workBook.SheetNames;

            this.importExcelData = XLSX.utils.sheet_to_json(workBook.Sheets[workSheet[0]], { defval: "" });
            //If user uploads different excel file
            if (workBook.SheetNames[0] !== this.s1[0]) { this.importing = false; this.toast.notify(serverMessage.supplierTarget.WorksheetError, "error"); this.onCancel(); }
            else {
              //if user uploads blank excel file
              if (this.importExcelData.length == 0) { this.importing = false; this.toast.notify(serverMessage.Blanksheeterror, "error"); this.onCancel(); }
              else {
                console.log(this.importExcelData);
                for (let i = 0; i < this.importExcelData.length; i++) {
                  this.importExcelData[i]["Supplier No"];
                  this.importExcelData[i]["Plant"];
                  this.importExcelData[i]["Supplier Name 1"];
                  this.importExcelData[i]["Supplier Name 2"];
                  this.importExcelData[i]["Supplier Country"];
                }
                this.importing = false;
                this.excelDatatoSend(this.importExcelData);
                this.hideExportImport = true;
                //this.Editable = false;
                this.toast.notify(serverMessage.excelImportMessage, "success");
              }
            }
          }
        }
      }
    }
  }

  excelDatatoSend(receivedExcelData) {
    // console.log(receivedExcelData);
    // const overheadCostData = this.formatData(receivedExcelData);
    this.modifiedExcelSupplierTargetRows = this.formatData(receivedExcelData);
    // console.log(this.modifiedExcelSupplierTargetRows);
    this.Editable = false;
    this.loadSupplierTargetData();
  }

  bindSupplierTargetData() {
    this.headerYears = [];
    this.supplierTargetService.getAllSupplierTargetData(Number(this.selectBusinessArea), Number(this.selectBusinessLine)).subscribe((data) => {
      this.getResponse = data;
      let successCode = this.getResponse.StatusCode;
      if (successCode != 200) {
        let errorMsgeFromBack = this.getResponse.Data.Message;
        let errorContainer = [
          { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
          { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
        ]
        this.openAlertDialog(errorContainer);
        return false;
      }
      else if (successCode == 200) {
        // console.log(data.Data);
        this.receivedData = data.Data;
        if (this.receivedData != "") {
          this.recievedSupplierTargetData = this.receivedData;
          // console.log(this.recievedSupplierTargetData);
        }
        else {
          //Static HeaderYears
          for (let val = 0; val < 10; val++) {
            this.headerYears.push(this.startYear + val);
          }
          this.rowData = [];
          this.showGrid = true;
          return;
        }

        let yearList = Array.from(new Set(this.receivedData.map(item => item.Year))).sort();
        let minYear = yearList[0];
        let maxYear = yearList[yearList.length - 1];

        let supplierTargetRow = [];
        const mergedMap = new Map();
        this.recievedSupplierTargetData.forEach(data => {
          const key = `${data.SupplierNo}-${data.Plant}-${data.SupplierName1}-${data.SupplierName2}-${data.SupplierCountry}`;
          if (mergedMap.has(key)) {
            const existingRecord = mergedMap.get(key);
            existingRecord[data.Year] = data.TargetValue;
          }
          else {
            let rowNode = {};
            rowNode["SupplierNo"] = data.SupplierNo;
            rowNode["Plant"] = data.Plant;
            rowNode["SupplierName1"] = data.SupplierName1;
            rowNode["SupplierName2"] = data.SupplierName2;
            rowNode["SupplierCountry"] = data.SupplierCountry;
            rowNode["IsActive"] = data.IsActive;
            rowNode["_isDeleted"] = false;   
            rowNode["_isSupplierTargetRow"] = true;
            for (let i = Number(minYear); i <= Number(maxYear); i++) {
              if (!this.headerYears.includes(i)) {
                this.headerYears.push(i);
              }
              rowNode[i] = null;
            }
            rowNode[data.Year] = data.TargetValue;
            mergedMap.set(key, rowNode);
          }
        })

        supplierTargetRow = Array.from(mergedMap.values());
        this.rowData = supplierTargetRow;
        this.getSupplierInfoData();
        // this.loadSupplierTargetData();
      }

    }, (error) => {
      this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }]);
      return false;
    });
  }

  // getSupplierInfoData() {
  //   this.showGrid = false;
  //   this.supplierTargetService.getAllSupplierInfoData(Number(this.selectBusinessArea), Number(this.selectBusinessLine)).subscribe((res: any) => {
  //     if (res == null) {
  //       return
  //     }
  //     else {
  //       this.supplierInfoMaster = res.Data;
  //       console.log(this.supplierInfoMaster);
  //       this.loadSupplierTargetData();
  //     }
  //   })
  // }
  getSupplierInfoData() {
    this.showGrid = false;
    this.supplierTargetService
      .getAllSupplierInfoData(Number(this.selectBusinessArea), Number(this.selectBusinessLine))
      .subscribe(
        (res: any) => {
          // Handle different response formats
          if (res == null) {
            this.supplierInfoMaster = [];
          } else if (Array.isArray(res.Data)) {
            this.supplierInfoMaster = res.Data;
          } else if (Array.isArray(res)) {
            this.supplierInfoMaster = res;
          } else {
            this.supplierInfoMaster = [];
          }

          // Build dropdown options from master data
          this.buildSupplierDropdowns();

          // Load grid with populated dropdown values
          this.loadSupplierTargetData();
        },
        (error) => {
          console.error('Error fetching supplier info:', error);
          this.supplierInfoMaster = [];
          this.buildSupplierDropdowns();
          this.loadSupplierTargetData();
        }
      );
  }

  private buildSupplierDropdowns(): void {
    // Create a map keyed by SupplierNo for O(1) lookup on selection
    const supplierMap = new Map<string, any>();

    // Extract unique values and build the map
    const supplierNos = new Set<string>();
    const supplierName1s = new Set<string>();
    const supplierName2s = new Set<string>();
    const supplierCountries = new Set<string>();

    this.supplierInfoMaster.forEach((item: any) => {
      if (item) {
        const no = (item.SupplierNo ?? "").toString().trim();
        const plant = (item.Plant ?? "").toString().trim();
        const name1 = (item.SupplierName1 ?? "").toString().trim();
        const name2 = (item.SupplierName2 ?? "").toString().trim();
        const country = (item.SupplierCountry ?? "").toString().trim();

        // Add to sets for uniqueness
        if (no) {
          supplierNos.add(no);
          // Store first occurrence in map for auto-fill
          if (!supplierMap.has(no)) {
            supplierMap.set(no, item);
          }
        }
        if (name1) supplierName1s.add(name1);
        if (name2) supplierName2s.add(name2);
        if (country) supplierCountries.add(country);
      }
    });

    // Convert sets to sorted arrays for dropdown display
    this.supplierNoOptions = Array.from(supplierNos).sort();
    this.supplierName1Options = Array.from(supplierName1s).sort();
    this.supplierName2Options = Array.from(supplierName2s).sort();
    this.supplierCountryOptions = Array.from(supplierCountries).sort();

    // Store map as property for auto-fill
    this['supplierByNoMap'] = supplierMap;
  }

  private autoFillSupplierData(params: any): void {
    const supplierMap = this['supplierByNoMap'] as Map<string, any>;
    const selectedSupplierNo = (params?.data?.SupplierNo ?? "").toString().trim();

    if (!selectedSupplierNo) {
      params.node.setDataValue("Plant", null);
      params.node.setDataValue("SupplierName1", null);
      params.node.setDataValue("SupplierName2", null);
      params.node.setDataValue("SupplierCountry", null);
      return;
    }

    const matchedSupplier = supplierMap.get(selectedSupplierNo);
    if (matchedSupplier) {
      params.node.setDataValue("Plant", matchedSupplier.Plant || null);
      params.node.setDataValue("SupplierName1", matchedSupplier.SupplierName1 || null);
      params.node.setDataValue("SupplierName2", matchedSupplier.SupplierName2 || null);
      params.node.setDataValue("SupplierCountry", matchedSupplier.SupplierCountry || null);
    }
  }

  loadSupplierTargetData() {
    this.columnDefs = [
      {
        headerName: "Supplier No",
        field: "SupplierNo",
        tooltipField: "SupplierNo",
        headerTooltip: "Supplier No",
        editable: true,
        cellEditor: "supplierAutocompleteEditor",   // ← custom editor with search
        cellEditorParams: { values: this.supplierNoOptions },
        cellStyle: (params) => params.data.SupplierNo == "" || params.data.SupplierNo == null
          ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" }
      },
      {
        headerName: "Plant",
        field: "Plant",
        tooltipField: "Plant",
        headerTooltip: "Plant",
        editable: false,
        cellStyle: (params) => params.data.Plant == "" || params.data.Plant == null
          ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" }
      },
      {
        headerName: "Supplier Name 1",
        field: "SupplierName1",
        tooltipField: "SupplierName1",
        headerTooltip: "Supplier Name 1",
        editable: false,                             // ← non-editable, auto-populated
        // cellStyle: (params) => params.data.SupplierName1 == "" || params.data.SupplierName1 == null
        //   ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" }
      },
      {
        headerName: "Supplier Name 2",
        field: "SupplierName2",
        tooltipField: "SupplierName2",
        headerTooltip: "Supplier Name 2",
        editable: false,                             // ← non-editable, auto-populated
        // cellStyle: (params) => params.data.SupplierName2 == "" || params.data.SupplierName2 == null
        //   ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" }
      },
      {
        headerName: "Supplier Country",
        field: "SupplierCountry",
        tooltipField: "SupplierCountry",
        headerTooltip: "Supplier Country",
        editable: false,                             // ← non-editable, auto-populated
        cellStyle: (params) => params.data.SupplierCountry == "" || params.data.SupplierCountry == null
          ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" }
      },
    ];

    this.headerYears.forEach((year, index) => {
      this.columnDefs.push({
        headerName: year,
        field: String(year),
        // tooltipField: year,
        headerTooltip: year,
        tooltipValueGetter: CurrencyCellRenderer,
        editable: true,
        singleClickEdit: true,
        cellRenderer: CurrencyCellRenderer,
        // cellEditor: "doublingEditor",
        minWidth: 50
      })
    });

    this.columnDefs.push({
      headerName: "Is active",
      field: "IsActive",
      tooltipField: "IsActive",
      headerTooltip: "Is active",
      editable: false,
      cellRenderer: IsActiveCellRenderer
    });

    this.columnDefs.push({
      headerName: "Action",
      headerTooltip: "Action",
      filter: false,
      width: 100,
      cellClass: 'center-align',
      cellRendererFramework: DeleteiconComponent,
      colId: "edit",
      sortable: false
    });

    this.defaultColDef = {
      // editable: true,
      filter: true,
      sortable: true,
      suppressMovable: true,
      singleClickEdit: true,
    };
    this.domLayout = 'autoHeight';
    this.showGrid = true;
    this.paginationPageSize = 50;
  }

  onClickCancel() {
    let valToEmit = {
      unsavedChanges: false,
      saveButtonClick: true
    }

    this.unSavedChanges.emit(valToEmit);
  }

  submit(event?: any) {
    let response = null;
    let postData: any;
    if (this.modifiedSupplierTargetrows.length != 0 || this.modifiedExcelSupplierTargetRows.length != 0) {
      if (this.modifiedExcelSupplierTargetRows.length != 0) {
        postData = {
          tCSupplierTargets: this.modifiedExcelSupplierTargetRows,
          UserId: this.loggedInUser.UserId,
          BusinessAreaId: Number(this.selectBusinessArea),
          BusinessLineId: Number(this.selectBusinessLine)
        };
      }
      else {
        postData = this.datTosSend();
      }
      this.showGrid = false;
      // console.log(postData);
      response = this.supplierTargetService.postData(postData).toPromise().then(res => {
        this.submitResponse = res;
        let successCode = this.submitResponse.StatusCode;
        let errorCode = this.submitResponse.Data.ErrorCode;
        let errorMsgeFromBack = this.submitResponse.Data.Message;
        if (successCode == 200) {
          if (errorCode == 0) {
            let valToEmit = {
              unsavedChanges: false,
              saveButtonClick: event == undefined ? false : true
            }
            this.unSavedChanges.emit(valToEmit);
            // end;
            this.toast.notify(serverMessage.dataSaveMessage, "success");
            this.modifiedSupplierTargetrows = [];
            (<HTMLInputElement>document.getElementById('file')).value = "";
            this.hideExportImport = false;
            this.bindSupplierTargetData();
            this.Editable = true;
            this.hideExportImport = false;
            return true;
          }
          else {
            //Show errorCode and errorMessage in the UI              
            let errorContainer = [
              { [serverMessage.serverNotSaveMessage]: serverMessage.serverErrorHeader },
              { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
            ]
            this.openAlertDialog(errorContainer);
            this.showGrid = true;
            return false;

          }
        }
        //Going in else means that success code is not. ie. Http Status from server is not ok.
        else {
          //Show errorCode and errorMessage in the UI           
          let errorContainer = [
            { [serverMessage.serverNotSaveMessage]: serverMessage.serverErrorHeader },
            { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
          ]
          this.openAlertDialog(errorContainer);
          this.showGrid = true;
          return false;
        }

      }, (error) => {
        this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }])
        this.showGrid = true;
        return false;
      }
      )
    }
    else {
      // changes;
      let valToEmit = {
        unsavedChanges: false,
        saveButtonClick: event == undefined ? false : true
      }
      this.unSavedChanges.emit(valToEmit);
      // end;
      return true;
    }
    return response;
  }

  datTosSend() {
    let sendSupplierTargetData = [];
    this.modifiedSupplierTargetrows.forEach(row => {
      if (row._isDeleted === true) {
        // ← CHANGED: DELETED ROW branch — set IsActive=false for every year-record of this supplier
        // Must iterate receivedData because the merged grid row doesn't have per-year IDs
        const matchingRecords = this.receivedData.filter(x =>
          x.SupplierNo == row.SupplierNo
          && x.Plant == row.Plant
          && x.SupplierName1 == row.SupplierName1
          && x.SupplierName2 == row.SupplierName2
          && x.SupplierCountry == row.SupplierCountry
        );
        matchingRecords.forEach(record => {
          sendSupplierTargetData.push({
            SupplierSpecificTargetId: record.SupplierSpecificTargetId,
            SupplierNo: record.SupplierNo,
            Plant: record.Plant,
            SupplierName1: record.SupplierName1,
            SupplierName2: record.SupplierName2,
            SupplierCountry: record.SupplierCountry,
            Year: record.Year,
            TargetValue: record.TargetValue,
            IsActive: false,
            ModifiedBy: this.loggedInUser.UserId,
            ModifiedOn: new Date().toISOString()
          });
        });

      } else {
        let years = Object.keys(row).filter(key => !isNaN(Number(key)) && row[key] !== null);
        years.forEach(year => {
          let supplierTargetrow: any = {};
          let targetIdrow = this.receivedData.find(x => x.SupplierNo == row.SupplierNo && x.Plant == row.Plant && x.SupplierName1 == row.SupplierName1 && x.SupplierName2 == row.SupplierName2 && x.SupplierCountry == row.SupplierCountry && x.Year == Number(year));
          supplierTargetrow["SupplierSpecificTargetId"] = targetIdrow == undefined ? 0 : targetIdrow.SupplierSpecificTargetId;
          supplierTargetrow["SupplierNo"] = row.SupplierNo;
          supplierTargetrow["Plant"] = row.Plant;
          supplierTargetrow["SupplierName1"] = row.SupplierName1;
          supplierTargetrow["SupplierName2"] = row.SupplierName2;
          supplierTargetrow["SupplierCountry"] = row.SupplierCountry;
          supplierTargetrow["Year"] = year;
          supplierTargetrow["TargetValue"] = Number(row[year]);
          supplierTargetrow["IsActive"] = true;
          if (supplierTargetrow.SupplierSpecificTargetId == 0 || (supplierTargetrow.SupplierSpecificTargetId != 0 && Number(targetIdrow.TargetValue) != Number(supplierTargetrow.TargetValue))) {
            sendSupplierTargetData.push(supplierTargetrow);
          }
        });
      }
    });

    // sendOverheadCostData = this.formatData(this.modifiedOverheadCostrows);
    this.refObject = {
      tCSupplierTargets: sendSupplierTargetData,
      UserId: this.loggedInUser.UserId,
      BusinessAreaId: Number(this.selectBusinessArea),
      BusinessLineId: Number(this.selectBusinessLine)
    }
    return this.refObject;
  }

  formatData(data) {
    let returnDTOData = [];
    data.forEach(row => {
      let years = Object.keys(row).filter(key => !isNaN(Number(key)) && row[key] !== null).sort();
      years.forEach(year => {
        let supplierTargetrow = {};
        let targetIdrow = this.receivedData.find(x => x.SupplierNo == row["Supplier No"] && x.Plant == row["Plant"] && x.SupplierName1 == row["Supplier Name 1"] && x.SupplierName2 == row["Supplier Name 2"] && x.SupplierCountry == row["Supplier Country"] && x.Year == Number(year));
        supplierTargetrow["SupplierSpecificTargetId"] = targetIdrow == undefined ? 0 : targetIdrow.SupplierSpecificTargetId;
        supplierTargetrow["SupplierNo"] = row["Supplier No"];
        supplierTargetrow["Plant"] = row["Plant"];
        supplierTargetrow["SupplierName1"] = row["Supplier Name 1"];
        supplierTargetrow["SupplierName2"] = row["Supplier Name 2"];
        supplierTargetrow["SupplierCountry"] = row["Supplier Country"];
        supplierTargetrow["Year"] = year;
        supplierTargetrow["TargetValue"] = Number(row[year]);
        returnDTOData.push(supplierTargetrow);
      })
    })
    return returnDTOData;
  }

  onCancel() {
    let valToEmit = {
      unsavedChanges: false,
      saveButtonClick: true
    }
    this.unSavedChanges.emit(valToEmit);
    this.hideExportImport = false;
    this.modifiedSupplierTargetrows = [];
    (<HTMLInputElement>document.getElementById('file')).value = "";
    this.bindSupplierTargetData();
    this.Editable = true;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi
    this.sizeToFitRefresh = 1;
  }

  onCellValueChanged(params) {

    const changedField = params?.colDef?.field;
    if (changedField === "SupplierNo") {
      this.autoFillSupplierData(params);
    }
    // changes;
    let valToEmit = {
      unsavedChanges: true,
      saveButtonClick: false

    }
    this.unSavedChanges.emit(valToEmit);
    // end;
    this.hideExportImport = true;
    let rowPushed = false;
    if (this.modifiedSupplierTargetrows.length == 0) {
      this.modifiedSupplierTargetrows.push(params.data);
      rowPushed = true;
    }
    else {
      this.modifiedSupplierTargetrows.forEach((row, index) => {
        if (row["SupplierNo"] == params.data["SupplierNo"] && row["Plant"] == params.data["Plant"] && row["SupplierName1"] == params.data["SupplierName1"] && row["SupplierName2"] == params.data["SupplierName2"] && row["SupplierCountry"] == params.data["SupplierCountry"]) {
          if (row._isDeleted === true) {
            this.modifiedSupplierTargetrows[index] = params.data;
          }
          rowPushed = true;
        }
      })
    }
    if (!rowPushed) {
      this.modifiedSupplierTargetrows.push(params.data);
    }
  }

  onGridSizeChanged(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  onFirstDataRendered(params) {
    params.api.sizeColumnsToFit();
  }

  onDisplayedColumnsChanged(event) {
    if (this.sizeToFitRefresh != 0) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  ngOnDestroy() {
    if (this.adminSubscription) {
      this.adminSubscription.unsubscribe()
    }
    if (this.deleteSubscription) {              // ← NEW: prevent memory leak
      this.deleteSubscription.unsubscribe();
    }
  }

}

//use to format the cell according to german currency format;
function CurrencyCellRenderer(params: any) {
  return params.value == undefined ? null : new Intl.NumberFormat(countryCode).format(params.value) + '%';
}

function IsActiveCellRenderer(params: any) {
  return params.value == true ? 'Yes' : 'No';
}
